<template>
  <div class="component-upload-image">
    <el-upload :action="uploadImgUrl" accept=".png, .jpg, .jpeg, .gif" :style="`width:${width}px;height:${height}px;`" list-type="picture-card" :on-success="handleUploadSuccess" :before-upload="handleBeforeUpload" :on-error="handleUploadError" name="file" :show-file-list="false" :headers="headers" style="display: inline-block; vertical-align: top">
      <el-image v-if="!value" :src="value">
        <div slot="error" class="image-slot">
          <i class="el-icon-plus" />
        </div>
      </el-image>
      <div v-else class="image">
        <el-image :src="value" :style="`width:${width}px;height:${height}px;`" fit="cover" />
        <div class="mask">
          <div class="actions">
            <span title="预览" @click.stop="dialogVisible = true">
              <i class="el-icon-zoom-in" />
            </span>
            <span title="移除" @click.stop="removeImage">
              <i class="el-icon-circle-close" />
            </span>
          </div>
        </div>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" title="预览" width="800" append-to-body>
      <img :src="value" style="display: block; max-width: 100%; margin: 0 auto;">
    </el-dialog>
  </div>
</template>

<script>
import { UploadFile } from '@/api/_user';
import { getToken } from '@/utils/auth'
import { compress } from '@/utils/index'
export default {
  data() {
    return {
      dialogVisible: false,
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload', // 上传的图片服务器地址
      headers: {
        Token: 'DU ' + getToken()
      },
    };
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    fileTxt: {
      type: String,
      default: "",
    },
    aliCloud: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "148",
    },
    height: {
      type: String,
      default: "148",
    },
  },

  methods: {
    removeImage() {
      this.$emit("input", "");
    },
    handleUploadSuccess(res) {
      this.loading.close();
      if (res.code === '0') {
        let url = res.data
        this.$emit("input", url);
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },

    handleBeforeUpload(file) {
      const suffix = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/bmp' || file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2
      const isGif = file.type === 'image/gif'
      if (!suffix) {
        this.$message.error('只能上传图片！')
        return false
      }
      // GIF动图不进行压缩，避免破坏动图效果
      if (!isLt2M && !isGif) {
        let that = this;
        compress(file, function (newFile) {
          const isLt2MN = newFile.size / 1024 / 1024 < 2
          if (!isLt2MN) return this.$message.error('上传图片大小不能超过 2MB!')
          that.beforeUpNew(newFile)
        })
        return false
      }
      // GIF文件如果超过2MB，直接提示
      if (!isLt2M && isGif) {
        this.$message.error('GIF动图大小不能超过 2MB!')
        return false
      }
      this.loading = this.$loading({
        lock: true,
        text: "上传中",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    /* 上传 */
    beforeUpNew(file) {
      var formData = new FormData();
      // file是上传的文件
      formData.append("file", file);
      //调用上传接口xxxxx接口地址
      UploadFile(formData).then((res) => {
        if (res.code === '0') {
          let url = res.data
          this.$emit("input", url);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    handleUploadError() {
      this.$message({
        type: "error",
        message: "上传失败",
      });
      this.loading.close();
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.image {
  position: relative;
  height: 100%;
}

.image .mask {
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.3s;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image:hover .mask {
  opacity: 1;
}
::v-deep .el-upload--picture-card {
  width: 100%;
  height: 100%;
  line-height: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    font-size: 22px;
  }
}
.el-icon-circle-close {
  position: absolute;
  right: -10px;
  top: -14px;
}
</style>